import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { Translate } from '../../../../../../../shared/LanguageService';

export function NoPhotographersWithTimeslotsAvailable() {
    return (
        <Box
            component="section"
            sx={{
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            <Typography
                variant="body1"
                sx={{
                    fontSize: '18px',
                    fontFamily: 'Roboto',
                    color: 'text.secondary',
                    textAlign: 'center',
                    padding: '20px 0'
                }}
            >
                {Translate('orders/list/bookings-calendar/no-photographers')}
            </Typography>
        </Box>
    );
}